import Mmenu from 'mmenu-js'

// mmenu navbars take an HTML string, so escape values before interpolating them.
const escapeHtml = (value) => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;')

const isHttpUrl = (value) => {
  try {
    return ['http:', 'https:'].includes(new URL(value, window.location.origin).protocol)
  } catch {
    return false
  }
}

const initMenu = () => {
  const menu = document.querySelector('#nav')
  const toggle = document.querySelector('.header__toggle')

  if (!menu) return

  const socialsData = window.siteData?.headerSocials || {}
  const socialsMap = {
    facebook_url: { label: 'facebook', icon: 'facebook.svg' },
    instagram_url: { label: 'instagram', icon: 'instagram.svg' },
    twitter_url: { label: 'twitter', icon: 'twitter.svg' },
    youtube_url: { label: 'youtube', icon: 'youtube.svg' },
    pintrest_url: { label: 'pinterest', icon: 'pinterest.svg' },
    snapchat_url: { label: 'snapchat', icon: 'snapchat.svg' },
    tiktok_url: { label: 'tiktok', icon: 'tiktok.svg' },
    linkedin_url: { label: 'linkedin', icon: 'linkedin.svg' }
  }

  const socialHtml = Object.entries(socialsMap)
    .filter(([key]) => socialsData[key] && isHttpUrl(socialsData[key]))
    .map(([key, { label, icon }]) => `
      <a href="${escapeHtml(socialsData[key])}" target="_blank" rel="nofollow noopener noreferrer">
        <img src="/wp-content/themes/fckluif-theme/img/${icon}" alt="${label}">
      </a>
    `)
    .join('')

  if (!socialHtml) return

  const mmenu = new Mmenu(menu, {
    scrollBugFix: true,
    titleLink: 'parent',
    slidingSubmenus: false,
    language: 'NL',
    offCanvas: {
      "position": "right-front"
    },
    navbar: false,
    navbars: [
      {
        position: 'top',
        content: [
          `
          <div class="mm-menu__social-icons">
            ${socialHtml}
          </div>
          `
        ]
      }
    ],
    toggleSubmenu: {
      text: "Toggle",
    }
  })

  if (toggle) {
    toggle.addEventListener('click', (e) => {
      e.preventDefault()
      mmenu.API.open()
    })
  }
}

export default initMenu